import * as React from "react";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/Login/login/loginScreen/yobScreen.scss";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import OtpForm, { IOtpFormProps } from "../forms/otpForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";
import EdButton from "../../generic/edButton";
import { useEffect } from "react";
import { getTolocalStorage } from "../../../Containers/Constants/commenFeatures";

export interface IOtpScreenProps extends IOtpFormProps {
  securityImgObj: any;
  onSwitchLoginFlow:(flow: string) => void;
}

const OtpWithAPi: React.FC<IOtpScreenProps> = (props) => {
  const [showSwitch, setShowSwitch] = React.useState(false);
  const [etotpSwitch, setEtotpSwitch] = React.useState(false);
  useEffect(() => {
    async function checkLoginFlow() {
      const loginFlow = await getTolocalStorage("LoginFlow");
      if (loginFlow === "OTP" || loginFlow === "TOTP") {
        setEtotpSwitch(false);
      } else {
        setEtotpSwitch(true);
      }
    }
    checkLoginFlow();
  }, []);
  return (
    <div className="loginWithApi">
      <div className="loginWithApi_container">
        <div className="loginWithApi_head">
          <span>
            <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
          </span>

          <span>
            <i className="edel-icon-close" onClick={props.onClose}></i>
          </span>
        </div>
        <div className="loginWithApi_contant">
          <div className="loginWithApi_appInfo">
            <img
              src={
                props.securityImgObj.logo
                  ? appUrl.appIcon + props.securityImgObj.logo
                  : DefaultAppIcon
              }
              alt="logo"
            />
            <h3>{props.securityImgObj.appNm}</h3>
          </div>
          <div className="login_form yob_form">
            <OtpForm {...props} />
            {etotpSwitch && (
            <>
            <label className="text-center blue-txt mg-t20 hoverPink" onClick={()=>setShowSwitch(!showSwitch)}>Problem with SMS / email OTP?</label>
            <div className="login_frm_btm_txt text-center mg-b40">
                {showSwitch && <EdButton
                value="Mobile App Code"
                btnTyp="blue-link"
                className="font-16 pd-t10"
                onClick={() => props.onSwitchLoginFlow("ETOTP")}
                />}
            </div>
            </>)}
          </div>         
        </div>
      </div>
    </div>
  );
};

export default OtpWithAPi;
